import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { useDismissRecommendation } from "@/react/hooks/recommendations/useDismissRecommendation";

import { CloseButton } from "./CloseButton";

export const DismissRecommendation = ({
  recommendationId,
}: {
  recommendationId: string;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { mutate: dismissRecommendation } = useDismissRecommendation({
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["recommendations"],
      });
      toast.success(t("members_directory.recommendations.messages.dismissed"));
    },
  });

  return (
    <CloseButton
      ariaLabel={t("members_directory.recommendations.actions.dismiss")}
      onClick={() => dismissRecommendation(recommendationId)}
    />
  );
};
